import { mapState } from 'vuex'
import { APP_CHANNEL } from 'common/utils/variables'

export default {
  data () {
    let version = location.pathname.match(/planbkTemplatev(\d+).html/)
    version = version && version[1]
    return {
      APP_CHANNEL,
      RESULT_VERSION: Number(version) || 1
    }
  },
  computed: {
    ...mapState({
      appPlatform: state => state.appPlatform
    }),
  }
}